module.exports = __webpack_public_path__ + "static/img/keduo.89209d58.atlas";